import { Navigate } from 'react-router-dom';

import { useSelectedStore } from '../stores/useSelected';

export const WorkspaceContextRedirect = () => {
    const { workspace, project } = useSelectedStore();

    if (workspace?.id && project?.id) {
        return <Navigate to={`/w/${workspace.id}/p/${project.id}`} replace />;
    }

    if (workspace?.id) {
        return <Navigate to={`/w/${workspace.id}`} replace />;
    }

    return <Navigate to="/w" replace />;
};
